// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AddCreationDiscountController from "./add_creation_discount_controller"
application.register("add-creation-discount", AddCreationDiscountController)

import AddToPrintlistController from "./add_to_printlist_controller"
application.register("add-to-printlist", AddToPrintlistController)

import AgeGateController from "./age_gate_controller"
application.register("age-gate", AgeGateController)

import AlertOnceController from "./alert_once_controller"
application.register("alert-once", AlertOnceController)

import AutoScrollToActiveController from "./auto_scroll_to_active_controller"
application.register("auto-scroll-to-active", AutoScrollToActiveController)

import CartAlertController from "./cart_alert_controller"
application.register("cart-alert", CartAlertController)

import CartIndicatorController from "./cart_indicator_controller"
application.register("cart-indicator", CartIndicatorController)

import CheckerController from "./checker_controller"
application.register("checker", CheckerController)

import ChoiceController from "./choice_controller"
application.register("choice", ChoiceController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import CreationInitController from "./creation_init_controller"
application.register("creation-init", CreationInitController)

import DetailsController from "./details_controller"
application.register("details", DetailsController)

import DevGridController from "./dev_grid_controller"
application.register("dev-grid", DevGridController)

import DropController from "./drop_controller"
application.register("drop", DropController)

import DropPanelController from "./drop_panel_controller"
application.register("drop-panel", DropPanelController)

import FollowBatchController from "./follow_batch_controller"
application.register("follow-batch", FollowBatchController)

import FollowController from "./follow_controller"
application.register("follow", FollowController)

import FormController from "./form_controller"
application.register("form", FormController)

import FrameController from "./frame_controller"
application.register("frame", FrameController)

import HelpController from "./help_controller"
application.register("help", HelpController)

import HiderController from "./hider_controller"
application.register("hider", HiderController)

import HotkeyLinkController from "./hotkey_link_controller"
application.register("hotkey-link", HotkeyLinkController)

import InitEventController from "./init_event_controller"
application.register("init-event", InitEventController)

import InputExpandController from "./input_expand_controller"
application.register("input-expand", InputExpandController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import LegalEntityController from "./legal_entity_controller"
application.register("legal-entity", LegalEntityController)

import LikeController from "./like_controller"
application.register("like", LikeController)

import MakeButtonController from "./make_button_controller"
application.register("make-button", MakeButtonController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MinmaxController from "./minmax_controller"
application.register("minmax", MinmaxController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import OverlayController from "./overlay_controller"
application.register("overlay", OverlayController)

import PaintingController from "./painting_controller"
application.register("painting", PaintingController)

import PaypalController from "./paypal_controller"
application.register("paypal", PaypalController)

import PickerController from "./picker_controller"
application.register("picker", PickerController)

import PlaceholderFollowController from "./placeholder_follow_controller"
application.register("placeholder-follow", PlaceholderFollowController)

import PriceCalculatorController from "./price_calculator_controller"
application.register("price-calculator", PriceCalculatorController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import RadioTabsController from "./radio_tabs_controller"
application.register("radio-tabs", RadioTabsController)

import RangeController from "./range_controller"
application.register("range", RangeController)

import RegistrationHintController from "./registration_hint_controller"
application.register("registration-hint", RegistrationHintController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ScrollerController from "./scroller_controller"
application.register("scroller", ScrollerController)

import ScrubController from "./scrub_controller"
application.register("scrub", ScrubController)

import SelectDefinitionsController from "./select_definitions_controller"
application.register("select-definitions", SelectDefinitionsController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import SelectLocationController from "./select_location_controller"
application.register("select-location", SelectLocationController)

import SlidesController from "./slides_controller"
application.register("slides", SlidesController)

import StarRateController from "./star_rate_controller"
application.register("star-rate", StarRateController)

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import SubmittableAreaController from "./submittable_area_controller"
application.register("submittable-area", SubmittableAreaController)

import SwitcherController from "./switcher_controller"
application.register("switcher", SwitcherController)

import TglController from "./tgl_controller"
application.register("tgl", TglController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeAgoController from "./time_ago_controller"
application.register("time-ago", TimeAgoController)

import TimeFormatController from "./time_format_controller"
application.register("time-format", TimeFormatController)

import TimeZoneInputController from "./time_zone_input_controller"
application.register("time-zone-input", TimeZoneInputController)

import TurboController from "./turbo_controller"
application.register("turbo", TurboController)

import VideoController from "./video_controller"
application.register("video", VideoController)
